export default ({ axios, mapQueryString }) => ({
    index: (branchGroup, query = {}) => axios.get(`/branch-groups/${branchGroup}/goods${mapQueryString(query)}`)
})


// WEBPACK FOOTER //
// ./src/api/branchGroupGoods.js